"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NamedMeta = void 0;
var React = require("react");
/**
 * e.g. <meta name="flex:template-id" content="1-en_US-Travel-Guide-Hotels-Desktop"/>
 */
var NamedMeta = /** @class */ (function () {
    function NamedMeta(name, content) {
        this.name = name;
        this.content = content;
    }
    NamedMeta.prototype.renderMetaElement = function () {
        return React.createElement("meta", { name: this.name, content: this.content });
    };
    return NamedMeta;
}());
exports.NamedMeta = NamedMeta;
//# sourceMappingURL=named-meta.js.map